module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1047-5309f902b8c0312c8ed96a5a260b9804.png";